<dialog-draggable-header>Create a TPR</dialog-draggable-header>

<mat-dialog-content>
    <form class="container" [formGroup]="form">
        <div class="row">
            <searchable-autocomplete class="col" [options]="data.programs" value="id" label="Program Name"
                filterBy="programNameYear" formControlName="programId">
            </searchable-autocomplete>
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="CSPC LH or Single" formControlName="stablePartCode1" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="Checking Fixture No" formControlName="toolNo" />
                <mat-error *ngIf="this.form.get('toolNo')?.hasError('pattern')">
                    Only a-z, A-Z, 0-9, -, and _ are allowed.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="CSPC RH" formControlName="stablePartCode2" />
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="Tool Name" formControlName="toolName" />
            </mat-form-field>
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="Part No LH or Single" formControlName="partNumber" />
            </mat-form-field>
        </div>
        <div class="row">
            <searchable-autocomplete class="col" [options]="data.fixtures" value="id" label="Fixture Type"
                filterBy="typeName" formControlName="typeId">
            </searchable-autocomplete>
            <mat-form-field class="col">
                <input matInput floatLabel="always" placeholder="Part No RH" formControlName="partNumber2" />
            </mat-form-field>
        </div>
        <div class="row">
            <searchable-autocomplete class="col" [options]="data.classes" value="id" label="Class" filterBy="span"
                formControlName="spanId">
            </searchable-autocomplete>
            <searchable-autocomplete class="col" [options]="data.designSources" value="id" label="Design Source"
                filterBy="sourceName" formControlName="designSourceId">
            </searchable-autocomplete>
        </div>
        <div class="row">
            <searchable-autocomplete class="col" [options]="data.engineers" value="id" label="Engineer"
                filterBy="lastFirstName" formControlName="engineerId">
            </searchable-autocomplete>
            <mat-form-field class="col">
                <input matInput [matDatepicker]="firstUserReqDatepicker" placeholder="1st User Req"
                    formControlName="fixtureRequired" />
                <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #firstUserReqDatepicker></mat-datepicker>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
    <button mat-raised-button [disabled]="form.invalid" color="primary" (click)="addTpr()">Save</button>
    <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>